import { minidenticon } from 'minidenticons';
import { useTranslation } from '@/shared/web/i18n/LanguageProvider';
import { cn } from '@/web/lib/utils';

export function SupportTeamAvatar({
  id,
  name,
  available,
  className,
}: {
  id: string;
  name: string;
  available?: boolean;
  className?: string;
}) {
  const { t } = useTranslation();
  const src = `data:image/svg+xml,${encodeURIComponent(minidenticon(id))}`;

  return (
    <span
      title={name}
      role="img"
      aria-label={available === undefined ? name : available ? t('{name}, available', { name }) : t('{name}, away', { name })}
      className={cn('relative inline-flex size-9 shrink-0 rounded-full bg-white p-0.5 ring-1 ring-black/10', className)}
    >
      <img src={src} alt="" className="size-full rounded-full" />
      {available !== undefined && (
        <span className={cn('absolute right-0 bottom-0 size-2.5 rounded-full ring-2 ring-white', available ? 'bg-emerald-500' : 'bg-zinc-400')} />
      )}
    </span>
  );
}
